import axios from "axios";
import React, { useEffect, useState } from "react";
import TableHeader from "../Utility/TableHeader";
import { Tooltip } from "react-tooltip";
import { EyeIcon, PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import DeleteConfirmation from "../Utility/DeleteConfirmation";
import { Pagination } from "../../helper/HelperTwo";
import { PencilSquareIcon } from "@heroicons/react/20/solid";
import { toast } from "react-toastify";


function CustomerList({
  customersDataList,
  setCustomersDataList,
  paginationCustomerData,
  setOpenDialogBoxForCustomers,
  setCustomersDatas,
  CustomersDatas,
  editId,
  setEditId,
  fetchCustomersData,
  setSaveBtn,
  setContactPersonDetails,
  setContact_details,
  setCurrentPage,
  setEditIdCryptForCustomers,
  setIsEditing,
  setEditCustomerIdCrypty,
  filterParams
}) {

  const userForView = JSON.parse(localStorage.getItem('user'));
  const customerPermissionForView = userForView?.customer_role_based_access?.some(
    (access) => access.label_id == 5 && access.label_value != 0
  );


  const userForDelete = JSON.parse(localStorage.getItem('user'));
  const customerPermissionForDelete = userForDelete?.customer_role_based_access?.some(
    (access) => access.label_id == 4 && access.label_value != 0
  );

  const headers = [
    "S No",
    "Name",
    "Company Name",
    "Email",
    "Phone",
    "Status",
    "Action",
  ];

  const handleViewForCustomers = async (id_crypt) => {

    setIsEditing(true);
    setOpenDialogBoxForCustomers(true);
    setEditCustomerIdCrypty(id_crypt);
    setSaveBtn("update");
    try {
      const response = await axios.get(
        `public/api/admin/customer/edit/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );



      setCustomersDatas((prev) => ({
        ...prev,
        name: response.data.customer.name,
        salutation: response.data.customer.salutation,
        first_name: response.data.customer.first_name,
        last_name: response.data.customer.last_name,
        company_name: response.data.customer.company_name,
        customer_display_name: response.data.customer.customer_display_name,
        customer_type: response.data.customer.customer_type,
        designation: response.data.customer.designation,
        department: response.data.customer.department,
        customer_email: response.data.customer.customer_email,
        customer_phone: response.data.customer.customer_phone,
        website: response.data.customer.website,
        gst_number: response.data.customerbillingdetails.gst_number,
        place_of_supply: response.data.customerbillingdetails.place_of_supply,
        contact_person: response.data.customer.contact_person,
        contact_number: response.data.customer.contact_number,
        contact_email: response.data.customer.contact_email,
        contact_designation: response.data.customer.contact_designation,
        attention: response.data.customerbillingdetails.attention,
        address_line_1: response.data.customerbillingdetails.address_line_1,
        address_line_2: response.data.customerbillingdetails.address_line_2,
        city: response.data.customerbillingdetails.city,
        state: response.data.customerbillingdetails.state,
        pin_code: response.data.customerbillingdetails.pin_code,
        phone: response.data.customerbillingdetails.phone,
        remarks: response.data.customerbillingdetails.remarks,
        country: response.data.customerbillingdetails.country,
      }));

      const customerOtherDetails = response.data.customerotherdetails || [];

    

      if (customerOtherDetails.length > 0) {
        setContact_details(
          customerOtherDetails.map((item) => ({
            contact_person: item.contact_person || "",
            contact_number: item.contact_number || "",
            contact_email: item.contact_email || "",
            contact_designation: item.contact_designation || "",
          }))
        );
      }
    } catch (err) {
    
      toast.error(err.response.data.message);
    }
  };

  const handlePageChange = (page) => {
    if (page !== "..." && !isNaN(page)) {
      const newPage = Number(page);
      setCurrentPage(newPage);
      fetchCustomersData(newPage, filterParams);
    }
  };

  return (
    <>
      <div className="grid md:grid-cols-1 gap-4">
        <div className="overflow-x-auto">
          <table className="min-w-full max-w-full divide-y divide-gray-300 mt-8">
            <TableHeader headers={headers} />
            <tbody className="divide-y divide-gray-200 bg-white">
              {paginationCustomerData.data?.map((customer, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50 transition duration-300 ease-in-out"
                >
                  <td className="py-4 px-4 text-center text-md whitespace-nowrap">
                    {index + 1}
                  </td>
                  <td className="py-4 px-4 text-center text-md text-gray-500 whitespace-nowrap">
                    {customer.first_name}
                  </td>
                  <td className="py-4 px-4 text-center text-md text-gray-500 whitespace-nowrap">
                    {customer.company_name}
                  </td>
                  <td className="py-4 px-4 text-center text-md text-gray-500 whitespace-nowrap">
                    {customer.customer_email}
                  </td>
                  <td className="py-4 px-4 text-center text-md text-gray-500 whitespace-nowrap">
                    {customer.customer_phone}
                  </td>
                  <td className="py-4 px-4 text-center text-md text-gray-500 whitespace-nowrap">
                    {customer?.status}
                  </td>

                  <td className="flex space-x-2 items-center justify-center py-4 px-4 text-center text-sm text-gray-500 whitespace-nowrap">
                    {/* <CustomerView id_crypt={customer.id_crypt}/> */}
                   {customerPermissionForView && 
                   <span
                   className="my-anchor-view relative group cursor-pointer bg-blue-400 rounded-md p-1"
                   onClick={() => handleViewForCustomers(customer.id_crypt)}
                 >
                   <EyeIcon className="h-5 w-5 text-white" />
                   <Tooltip
                     anchorSelect=".my-anchor-view"
                     place="top"
                     className="text-xs p-0"
                     style={{ fontSize: "12px", padding: "0.3rem" }}
                   >
                     View
                   </Tooltip>
                 </span>
                   } 
                    
                   {customerPermissionForDelete && 
                   <DeleteConfirmation
                   id_crypt={customer.id_crypt}
                   apiType="customer"
                   fetchClientData={fetchCustomersData}
                 />
                   } 
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {paginationCustomerData && (
          <Pagination
            links={paginationCustomerData.links}
            currentPage={paginationCustomerData.current_page}
            totalResults={paginationCustomerData.total}
            from={paginationCustomerData.from}
            to={paginationCustomerData.to}
            lastPage={paginationCustomerData.last_page}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
}

export default CustomerList;
